import { formatPercent, formatTenure } from "./chartTheme";

const Tile = ({ label, value, note }) => (
  <div className="ws-kpi">
    <div className="ws-kpi__label">{label}</div>
    <div className="ws-kpi__value">{value}</div>
    {note && <div className="ws-kpi__note">{note}</div>}
  </div>
);

const years = (value) => (value === null || value === undefined ? "-" : `${Math.round(value)} yrs`);

const count = (value) => (typeof value === "number" ? value.toLocaleString() : "-");

/** The old "Employee Statistics" card as tiles (same figures, same names),
 *  plus tenure, age and nationalities.
 *
 *  "Employees on notice period" is people whose last working day is still
 *  ahead. The old card used that label for every leaver whose end of service
 *  was not approved, however long ago they left; that figure is kept as
 *  "Final settlement pending" so neither number is lost. */
export const OverviewKpis = ({ stats, summary }) => (
  <div className="ws-kpis">
    <Tile label="Total active workforce" value={count(stats?.total_employees)} note="not on notice" />
    <Tile label="Employees on notice period" value={count(summary?.serving_notice)} note="last working day ahead" />
    <Tile label="Final settlement pending" value={count(stats?.total_eos_pending_employees)} note="left, end of service not approved" />
    <Tile label="Average tenure" value={formatTenure(summary?.average_tenure_months)} note="time with the company" />
    <Tile label="Average age" value={years(summary?.average_age)} note="where date of birth is known" />
    <Tile label="Nationalities" value={count(summary?.nationalities)} note="represented today" />
  </div>
);

/** Movement over the selected period. */
export const TurnoverKpis = ({ summary, period }) => {
  if (!summary) return null;
  return (
    <div className="ws-kpis">
      <Tile label="Hires" value={summary.hires.toLocaleString()} note={period} />
      <Tile label="Leavers" value={summary.leavers.toLocaleString()} note={period} />
      <Tile label="Turnover, annualised" value={formatPercent(summary.turnover_rate)} note={`per year, based on ${period}`} />
      <Tile label="Left within 3 months" value={formatPercent(summary.early_attrition_rate)} note={`${summary.early_leavers} of ${summary.leavers} leavers`} />
      <Tile label="Voluntary exits" value={formatPercent(summary.voluntary_rate)} note="resigned or absconded" />
      <Tile label="Headcount today" value={summary.headcount.toLocaleString()} note="for scale" />
    </div>
  );
};
